import { AdditionalProduct, EnterpriseAdditionalProduct, EnterpriseBillingOption, EnterpriseBillingPackage, Plan } from '../../models/Plan'

export const mapEnterpriseBillingOptions = (
  enterpriseBillingPackage: EnterpriseBillingPackage,
  billingOptions: EnterpriseBillingOption[],
  globalPlans: Plan[],
): Plan[] => {
  const plans = billingOptions.reduce((acc: Record<string, Plan>, billingOption: EnterpriseBillingOption) => {
    const { planId, period, customPrice, additionalProducts } = billingOption
    const plan = acc[planId] ?? globalPlans.find((p) => p.id === planId)
    if (!plan) {
      console.error('Plan not found for planId: ', planId)
      return acc
    }

    const trialPeriodDays = enterpriseBillingPackage.type === 'selfPaid' ? enterpriseBillingPackage.freeTrialDays : 0
    const deltaTrialDays = enterpriseBillingPackage.type === 'selfPaid' ? enterpriseBillingPackage.deltaTrialDays : 0
    const updatedPlan = acc[planId] ?? { ...plan, trialPeriodDays, deltaTrialDays, prices: [] }
    const price = customPrice ?? plan.prices.find((p) => p.period === period)
    if (price) {
      updatedPlan.prices = [...updatedPlan.prices, price]
    }

    updatedPlan.additionalProducts = additionalProducts.reduce((products: AdditionalProduct[], enterpriseProduct: EnterpriseAdditionalProduct) => {
      if (!products.find((p) => p.type === enterpriseProduct.type)) {
        products.push({
          name: enterpriseProduct.type,
          type: enterpriseProduct.type,
          prices: [],
        })
      }
      return products
    }, [])

    acc[planId] = updatedPlan
    return acc
  }, {})

  return Object.values(plans)
}
